import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderPopService {
  public notifySubject = new Subject();
  constructor() { }

}

export interface LoaderPopConfig {
  createAction: boolean;
}

